import { render, staticRenderFns } from "./miniappSet.vue?vue&type=template&id=3e3b9a14&scoped=true&"
import script from "./miniappSet.vue?vue&type=script&lang=js&"
export * from "./miniappSet.vue?vue&type=script&lang=js&"
import style0 from "./miniappSet.vue?vue&type=style&index=0&id=3e3b9a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b9a14",
  null
  
)

export default component.exports